import { render, staticRenderFns } from "./BingoHalls.vue?vue&type=template&id=6881510e"
import script from "./BingoHalls.vue?vue&type=script&lang=js"
export * from "./BingoHalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports